// Enums
export enum BdcRoomType {
  BEDROOM_SUBROOM = 'BEDROOM_SUBROOM',
  LIVING_ROOM_SUBROOM = 'LIVING_ROOM_SUBROOM',
  GUEST_ROOM = 'GUEST_ROOM',
}

export enum BdcSmokingPolicy {
  SMOKING = 'SMOKING',
  NONSMOKING = 'NONSMOKING',
  SMOKING_AND_NONSMOKING = 'SMOKING_AND_NONSMOKING',
}

export const bdcSmokingPolicyOptions = [
  { label: 'Smoking', value: BdcSmokingPolicy.SMOKING },
  { label: 'Non-smoking', value: BdcSmokingPolicy.NONSMOKING },
  { label: 'Smoking and non-smoking', value: BdcSmokingPolicy.SMOKING_AND_NONSMOKING },
]

export enum BdcSizeUnit {
  SQM = 'SQM',
  SQFT = 'SQFT',
}

// Interfaces
export interface IBdcBed {
  bed_type_id: number
  bed_count: number
}

export interface IBdcBedConfiguration {
  beds: IBdcBed[]
  is_default_configuration: boolean
}

export interface IBdcRoom {
  type: BdcRoomType
  bed_configurations?: IBdcBedConfiguration[]
}

export interface IBdcConfiguration {
  unit_type_id: number
  rooms: IBdcRoom[]
}

export interface IBdcSize {
  value: number
  unit: BdcSizeUnit
}

export interface IBdcOccupancy {
  max_guests: number
  max_adults: number
  max_children: number
}

export interface IBdcOccupancyCreate {
  max_guests?: number
  max_adults?: number
  max_children?: number
}

export interface IBdcExtraBedsConfiguration {
  extra_beds: number
  cribs: number
  is_crib_and_extra_bed_allowed: boolean
}

export interface IBdcExtraBedsConfigurationCreate {
  extra_beds?: number
  cribs?: number
  is_crib_and_extra_bed_allowed?: boolean
}

// Common base interface for both Unit and UnitCreate
export interface IBdcUnitBase {
  configuration?: IBdcConfiguration
  unit_name_id?: number
  number_of_units?: number
  smoking_policy?: BdcSmokingPolicy
  size?: IBdcSize
  partner_reference_name?: string
  floor_numbers_located_on?: number[]
  max_children_that_pay_children_rate?: number
}

export interface IBdcUnitBaseWithConfiguration extends IBdcUnitBase {
  configuration: IBdcConfiguration
  unit_name_id: number
}

export interface BdcCreateUnitPayload extends IBdcUnitBaseWithConfiguration {
  occupancy?: IBdcOccupancyCreate
  extra_beds_configuration?: IBdcExtraBedsConfigurationCreate
}

export interface BdcUpdateUnitPayload extends IBdcUnitBase {
  configuration?: IBdcConfiguration
  unit_name_id?: number
}

export interface BdcUnitResponse extends IBdcUnitBaseWithConfiguration {
  unit_id: number
  occupancy: IBdcOccupancy
  extra_beds_configuration: IBdcExtraBedsConfiguration
  unit_name_fallback?: string
}
